import styled from "styled-components"

import tokens from "../_tokens"

const DescriptionList = styled.dl`
  padding: 0;

  dt {
    padding: 0;
    margin-top: ${1.5 * tokens.size.base}px;
    font-size: 1em;
    font-style: italic;
    font-weight: 600;
  }

  dd {
    padding: 0 ${1.5 * tokens.size.base}px;
    margin: 0 0 ${1.5 * tokens.size.base}px;
  }
`

export default DescriptionList
